import { useDispatch, useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { ReadMoreButton } from '../../../ui/ReadMoreButton';
import AppActions from 'app/shared/flux/actions/AppActions';
import {
  emitTrackBuildingPayPerLinkClickEvent,
  emitTrackLowerPpcClickEvent,
} from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import NewWindowTealIcon from 'images/icons/new-window-teal.svg';
import { container, externalIcon, websiteContainer, websiteLink } from './aboutTheBuildingModule.styles';

export const AboutTheBuildingModule = () => {
  const dispatch = useDispatch();

  const currentListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  const displayName = currentListing?.displayName;
  const fullDescription = currentListing?.details?.fullDescription;
  const websiteUrl = currentListing?.details?.webSite;
  const websiteDomain = currentListing?.details?.webSiteOriginalDomain;

  if (!fullDescription && !websiteUrl) {
    return null;
  }

  const handleWebsiteClick = () => {
    dispatch(AppActions.sendEventToApi('building_website_visited', null));

    if (currentListing?.maloneLotIdEncoded) {
      dispatch(AppActions.sendEventToApi('building_website_clicked', currentListing.maloneLotIdEncoded));
    }

    emitTrackLowerPpcClickEvent({ triggerLocation: 'home_details_halo' });
    emitTrackBuildingPayPerLinkClickEvent({
      triggerObject: 'home_details_component|property_details',
      triggerLocation: 'home_details_halo',
    });
  };

  const websiteLinkText =
    displayName || (websiteDomain && !isUglyDomain(websiteDomain) ? `Visit ${websiteDomain}` : 'Property website');

  return (
    <div className={container}>
      {fullDescription && (
        <ReadMoreButton
          content={fullDescription}
          maxTruncatedLength={150}
          readMoreText="Read more"
          readLessText="Read less"
          aria-label="Building description"
        />
      )}

      {websiteUrl && (
        <div className={websiteContainer}>
          <a
            href={websiteUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            onClick={handleWebsiteClick}
            className={websiteLink}
            aria-label={displayName ? `Visit ${displayName} website` : `Visit property website: ${websiteUrl}`}
          >
            {websiteLinkText}
            <img src={NewWindowTealIcon} alt="" className={externalIcon} aria-hidden="true" />
          </a>
        </div>
      )}
    </div>
  );
};

function isUglyDomain(domain: string): boolean {
  return domain.split('.').length > 3 || domain.includes('prospectportal') || domain.includes('reslisting');
}
